module.exports = __webpack_public_path__ + "img/1.d06b6df4.jpg";